import { Navigate } from 'react-router-dom';

// Wraps any route that requires the user to be logged in.
// If there's no token in localStorage, redirects to /login instead
// of rendering the actual page — prevents someone from directly typing
// a URL like /dashboard and seeing a broken screen with failed API calls.
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
